'use strict';

module.exports = {
  OAUTH_AUTHORISE_URL: 'https://api.mendeley.com/oauth/authorize',
  OAUTH_TOKEN_URL: 'https://api.mendeley.com/oauth/token',
  ACCESS_TOKEN_COOKIE_NAME: 'accessToken',
  OAUTH_DEFAULT_SCOPE: 'all',
  AUTHENTICATE_ON_START: true
};



//////////////////
// WEBPACK FOOTER
// ./lib/auth/defaults.js
// module id = 63
// module chunks = 0